import React from 'react';
import { Grid2x2, House, Heart, ShoppingCart, Moon, Sun } from 'lucide-react';
import './MobileTaskbar.css';

export default function MobileTaskbar({
  cartCount,
  theme,
  onHome,
  onCategories,
  onWishlist,
  onCart,
  onToggleTheme,
}) {
  return (
    <nav className="mobile-taskbar" aria-label="Mobile quick actions">
      <button type="button" className="mobile-taskbar-item" onClick={onCategories}>
        <Grid2x2 size={18} />
        <span>Categories</span>
      </button>
      <button type="button" className="mobile-taskbar-item" onClick={onHome}>
        <House size={18} />
        <span>Home</span>
      </button>
      <button type="button" className="mobile-taskbar-item" onClick={onWishlist}>
        <Heart size={18} />
        <span>Wishlist</span>
      </button>
      <button type="button" className="mobile-taskbar-item" onClick={onCart}>
        <div className="mobile-taskbar-cart-wrap">
          <ShoppingCart size={18} />
          {cartCount > 0 && <span className="mobile-taskbar-badge">{cartCount}</span>}
        </div>
        <span>Cart</span>
      </button>
      <button type="button" className="mobile-taskbar-item" onClick={onToggleTheme}>
        {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        <span>Mode</span>
      </button>
    </nav>
  );
}
